import React from "react";
import Box from "@mui/material/Box";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';

type QuickSearchToolbarProps = {
    searchText: string;
    setSearchText: React.Dispatch<React.SetStateAction<string>>;
};

export function QuickSearchToolbar({ searchText, setSearchText }: QuickSearchToolbarProps) {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <TextField
                label="Search Mars Classes"
                variant="outlined"
                size="small"
                placeholder="Search…"
                value={searchText}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setSearchText(event.target.value);
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="clear search"
                                onClick={() => setSearchText("")}
                                edge="end"
                                size="small"
                                sx={{ visibility: searchText ? 'visible' : 'hidden' }}
                            >
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
}